import React from 'react';
import { useTranslation } from 'react-i18next'; // Import useTranslation
import style from "./index.module.scss"
import LupeIcon from "../../icons/LupeIcon";
import {onDebounce} from "../../../../utils";

const InputSearch = ({ placeholder, onGetText }) => { // Remove default value
  const { t } = useTranslation(); // Initialize useTranslation
  const updateText = event => {
    onDebounce(() => onGetText(event.target.value))
  }
  return (
    <div className={style.wrapper}>
      <label className={style.icon} htmlFor="InputSearch">
        <LupeIcon />
      </label>
      <input
        id="InputSearch"
        className={style.input}
        // Use t() for placeholder, fallback to prop or default key
        placeholder={placeholder || t('common.placeholder.search')}
        onChange={updateText}
      />
    </div>
  );
};

export default InputSearch;
